import { AgentKey } from '~/agents/common/common/types'

export enum OrganizationMetricsTaskType {
  EMAIL_PROCESSED = 'email_processed',
  EMAIL_DRAFTED = 'email_drafted',
  SOCIAL_POST_DRAFTED = 'social_post_drafted',
  BLOG_POST_DRAFTED = 'blog_post_drafted',
  LEAD_CONTACTED = 'lead_contacted',
}

export enum OrganizationMetricsEmployee {
  COMMUNITY_MANAGER = 'community_manager',
  EXECUTIVE_ASSISTANT = 'executive_assistant',
  CONTENT_WRITER = 'content_writer',
  SALES_OUTBOUND = 'sales_outbound',
}

export type OrganizationMetricsWeeklySummaries = Record<
  string,
  OrganizationMetricsSummary
>

export type OrganizationMetricsTasks = Record<
  Partial<OrganizationMetricsTaskType>,
  number
>

export type OrganizationMetricsSummary = {
  timeSaved: number
  moneySaved: number
}

export type OrganizationMetricsTaskComputed = {
  count: number
  timeSaved: number
  moneySaved: number
}

export type OrganizationMetricsComputed = {
  tasks: Partial<
    Record<OrganizationMetricsTaskType, OrganizationMetricsTaskComputed>
  >
  summary: {
    timeSaved: number
    moneySaved: number
  }
}

export type OrganizationMetricsEmployeeConfigType = {
  hourlyRate: number // in USD
  appKey: AgentKey
}

export type OrganizationMetricsTaskConfigType = {
  labels: {
    singular: string
    plural: string
  }
  labelUnit: string
  timeEstimate: number // in hours
  employee: OrganizationMetricsEmployee
}
